var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.allowed)?_c('div',[_vm._v(" Not allowed ")]):_c('FolderList',{attrs:{"resources":_vm.resources}})
}
var staticRenderFns = []

export { render, staticRenderFns }